"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SHFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_205)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_205`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.92236 0H28.0812V24H-7.92236V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.0794 0V8.25549H6.83767L10.0794 10.4143V12.0035H8.49018L3.32874 8.5649V12.0035H-1.1717V8.5649L-6.33315 12.0035H-7.92236V10.4143L-4.68064 8.25549H-7.92236V3.75505H-4.68064L-7.92236 1.59625V0H-6.33315L-1.1717 3.43862V0H3.32874V3.43862L8.49018 0H10.0794Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.20363 0H-0.0465937V4.88016H-7.92236V7.13038H-0.0465937V12.0035H2.20363V7.13038H10.0794V4.88016H2.20363V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.92236 0V1.06182L-3.88603 3.75505H-2.29681L-7.92236 0ZM10.0794 0V1.06182L6.04306 3.75505H4.45385L10.0794 0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.0794 1.59625V3.75506H6.83771L10.0794 1.59625Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.92236 0V1.06182L-3.88603 3.75505H-2.29681L-7.92236 0ZM10.0794 0V1.06182L6.04306 3.75505H4.45385L10.0794 0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.0794 1.59625V3.75506H6.83771L10.0794 1.59625Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.92236 12.0035V10.9417L-3.88603 8.25549H-2.29681L-7.92236 12.0035ZM10.0794 12.0035V10.9417L6.04306 8.25549H4.45385L10.0794 12.0035Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M23.651 9.82361C23.644 12.9458 23.1447 16.3 19.0803 17.9033C15.0158 16.3 14.5166 12.9458 14.5095 9.82361H23.651Z",
					fill: "#29DBFF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M23.6511 9.82361C23.6511 8.64928 23.5878 7.5101 23.6159 6.51157C22.097 5.8365 20.0929 5.69586 19.0733 5.69586C18.0536 5.69586 16.0566 5.8365 14.5306 6.51157C14.5588 7.5101 14.4955 8.64928 14.4955 9.82361H23.6511Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.0607 14.3803L18.0818 15.1046L17.1817 15.1187L17.5263 16.0469H16.3097C15.044 14.6264 14.6643 13.0654 14.5588 11.2581L15.1987 10.576L15.7823 11.5816L16.5418 10.6815L17.034 11.23L17.0903 12.334L18.0607 14.3803Z",
					fill: "#BF521B"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.7791 13.5365L22.1743 14.8233H18.8693L16.816 13.4521L18.6232 14.1904H20.3882L20.6484 13.7334L21.1547 13.7474L21.2953 13.5365H22.7791Z",
					fill: "#474747"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_205`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SHFlag };
